<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>

<div class="dash">
  <!-- Vendor Summary -->
  <div *ngIf="activeTab === 'summary'" class="vendor-summary mt-3">
    <h4 class="text-center">Total Vendors: {{ totalVendors }}</h4>
    <div class="d-flex justify-content-between mb-2 me-3 ms-3">
      <p-iconfield iconPosition="left" class="me-4 d-flex align-items-center">
        <input
          pInputText
          type="text"
          (input)="onGlobalFilter($event, summaryTable)"
          placeholder="Search Region"
          class="form-control rounded-pill px-3"
        />
      </p-iconfield>
    </div>
  
    <p-table
      #summaryTable
      [value]="vendorSummaryList"
      [scrollable]="true"
      styleClass="p-datatable-gridlines"
      scrollHeight="calc(100vh - 165px)"
      sortMode="single"
      [sortField]="'Cluster'"
      [sortOrder]="1"
      [responsiveLayout]="'scroll'"
      [globalFilterFields]="['Cluster']">

      <ng-template pTemplate="header">
        <tr>
          <th class="text-center" style="display: inline !important;" pSortableColumn="Cluster">Region <p-sortIcon field="Cluster"></p-sortIcon></th>
          <th class="text-center" style="display: inline !important;" pSortableColumn="totalrecords">Number of Vendors <p-sortIcon field="totalrecords"></p-sortIcon></th>
          <th class="text-center" style="display: inline !important;">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-region style="display: inline !important;">
        <tr>
          <td class="text-center" style="display: inline !important;">{{ region.Cluster }}</td>
          <td class="text-center" style="display: inline !important;">{{ region.totalrecords }}</td>
          <td class="text-center" style="display: inline !important;">
            <button class="btn btn-primary btn-sm" (click)="viewRegion(region.Cluster,region.totalrecords)">View Vendors</button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Vendor List -->
  <div *ngIf="activeTab === 'list'" class="vendor-list mt-4">
    <button class="btn btn-outline-secondary mb-3" (click)="activeTab = 'summary'">
      ← Back to Summary
    </button>

    <h3 class="text-center fw-semibold mb-2 text-primary">Vendor List</h3>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="mb-0" *ngIf="selectedRegion">
        Vendors in {{ selectedRegion }}: {{ regionCount }}
      </h6>

      <p-iconfield iconPosition="left" class="me-4 d-flex align-items-center">
        <input
          pInputText
          type="text"
          (input)="onGlobalFilter($event, dt)"
          placeholder="Search Vendors"
          class="form-control rounded-pill px-3"
        />
      </p-iconfield>

    </div>

    <p-table
      #dt
      [value]="vendorList"
      [paginator]="true"
      [rows]="10"
      sortMode="single"
      [sortField]="'company_name'"
      [sortOrder]="1"
      [globalFilterFields]="['company_name', 'name', 'phone_no', 'truck_types', 'address', 'onboard_status']"
      [autoLayout]="true" 
      [responsiveLayout]="'stack'"  
      styleClass="p-datatable-gridlines"
      [tableStyle]="{ width: '100%' }">
      
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="company_name" style="width: 20%">Company Name <p-sortIcon field="company_name"></p-sortIcon></th>
          <th pSortableColumn="name" style="width: 20%">Vendor Name <p-sortIcon field="name"></p-sortIcon></th>
          <th style="width: 10%">Mobile</th>
          <th pSortableColumn="truck_types" style="width: 10%">Truck Types <p-sortIcon field="truck_types"></p-sortIcon></th>
          <th style="width: 30%">Address</th>
          <th style="width: 10%">Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-vendor>
        <tr>
          <td style="width:20%">{{ vendor.company_name | titlecase }}</td>
          <td style="width:20%">{{ toTitleCase(vendor.name) }}</td>
          <td style="width:10%">{{ vendor.phone_no }}</td>
          <td style="width:10%">{{ vendor.truck_types?.join(', ') | titlecase }}</td>
          <td style="width:30%">{{ toTitleCase(vendor.address) }}</td>
          <td style="width:10%">{{ toTitleCase(vendor.onboard_status) }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
